
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';

import { BackupdbService } from 'api/backupdb/backupdb.service';
import { ApiConstant} from 'api/api.constant';

declare var $: any;
@Component({
    selector: 'backupdb-page',
    templateUrl: './backupdb.html'
})

export class BackupdbComponent implements OnInit {
   
    fileList = [];
    dbNAme: string;
    mainURL: string;
    flag: boolean;

    constructor(private router: Router, private backupdbService: BackupdbService, private apiConstant: ApiConstant) { }

    ngOnInit() {

        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'ADMIN' || localStorage.getItem('type') == 'SUPERCLIENT' || localStorage.getItem('type') == 'CLIENT')) {
            $(function () {
            })
            this.flag = true;
            this.initLevel();
        } else {
            this.router.navigate(['/']);
        }
    }


    initLevel() {
        this.fileList = [];
        this.backupdbService
        .list()
        .then(data1 => {
            this.fileList = data1.data;
            this.flag = false;
        })
    }

    backupButton() {
        this.flag = true;
        this.backupdbService
        .datbaseBackup()
        .then(data => {
            if (data.status == true) 
            {
                this.initLevel();
            }
            else {
                this.flag = false;
                $.notify({
                    message: data.message
                }, 
                {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
            }
        });
    }
   
    openDB(file) {
        this.dbNAme = file.fileName;
        this.mainURL = this.apiConstant.DatabaseUrl;

        window.location.href = this.mainURL + 'BackupDB/' + this.dbNAme;
    }

    deleteDB(file) {
        this.dbNAme = file.fileName;
    }

    delete() {
        this.backupdbService
        .deleteDB(this.dbNAme)
        .then(data => {
            if (data.status == true) {
                this.initLevel();
                $.notify({
                    message: data.message
                }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                $(function () {
                    $('#deleteModal').modal('toggle');
                });
                
            } else {
                $.notify({
                    message: data.message
                },
                {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
            }
        });
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/backupDB/backupdb.page.ts